import type { IconComponentFunction } from '@motorway/mw-highway-code';
import { Icon, MotorwayChevronIcon, VerifiedIcon } from '@motorway/mw-highway-code';

import { otpModalShow } from 'Components/pages/VehiclePayment/components/OTPModal/emitter/OTPModalEmitter.events';
import { SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import { vehiclePaymentEvents } from 'Services/analytics/events/paymentEvents/vehiclePaymentEvents';
import type { PaymentProviderKey } from 'Services/motorway/services/paymentOptions/paymentOptions.types';

import { ReactComponent as LECLogo } from './assets/lecapital-logo.svg';
import { ReactComponent as NGLogo } from './assets/next-gear-logo.svg';

export const NextGearLogoIcon: IconComponentFunction = (props) => (
	<Icon {...props}>
		<NGLogo />
	</Icon>
);

export const LECapitalLogoIcon: IconComponentFunction = (props) => (
	<Icon {...props}>
		<LECLogo />
	</Icon>
);

export const getHandlePaymentClick = (buttonLabel: string, label: string) => {
	return () =>
		new Promise<void>((resolve) => {
			vehiclePaymentEvents<{
				/* eslint-disable-next-line local-rules/interfaces-types-properties-naming */
				button_label: string;
				label: string;
				url: string;
			}>({
				customData: {
					button_label: buttonLabel,
					label,
					url: '/payment-processing',
				},
				name: 'Stock funding request button clicked',
				schemaName: SNOWPLOW_EVENTS.CTA_CLICKED.SCHEMA,
				version: SNOWPLOW_EVENTS.CTA_CLICKED.VERSION,
			});
			otpModalShow({
				onDismiss: resolve,
			});
		});
};

export const LOGO_BY_PROVIDER: Record<PaymentProviderKey, IconComponentFunction> = {
	'stock-funding-lecapital': LECapitalLogoIcon,
	'stock-funding-motonovo': VerifiedIcon,
	'stock-funding-nextgear': NextGearLogoIcon,
	'wallet-modulr': MotorwayChevronIcon,
};
